import { MagnifyingGlassIcon } from '@heroicons/react/24/solid';
import {
  Checkbox,
  Flex,
  Radio,
  ScrollArea,
  Space,
  Stack,
  TextInput,
  Title
} from '@mantine/core';
import { FormattedMessage, useIntl } from 'react-intl';

import { LBButton, LBCheckbox, LBRadio } from '@/shared/ui-kit/components';
import { useChoseOptionsWithSearch } from '@/shared/view/chose-options-with-search/hooks/useChoseOptionsWithSearch';

type ChoseVariant = {
  onSelect: (value: string | string[]) => void;
  title: string;
  selectElement: 'checkbox' | 'radio';
  data: { label: string; value: string }[];
  initialValues: string | string[];
};

export const ChoseOptionsWithSearch = ({
  onSelect,
  title,
  data,
  selectElement,
  initialValues
}: ChoseVariant) => {
  const { state, functions } = useChoseOptionsWithSearch({
    data,
    initialValues
  });
  const { formatMessage } = useIntl();
  return (
    <div>
      <Title>{title}</Title>
      <Space h={24} />
      <TextInput
        placeholder={formatMessage({ id: 'form.search.placeholder' })}
        rightSection={<MagnifyingGlassIcon width={24} />}
        value={state.search}
        onChange={(value) => functions.setSearch(value.target.value)}
      />
      <Space h={32} />
      {selectElement === 'radio' && (
        <Radio.Group
          value={state.value as string}
          onChange={(value) => functions.setValue(value)}
        >
          <ScrollArea mih='50vh' type='never'>
            <Stack gap={16}>
              {state.filteredCity.map((item) => (
                <LBRadio
                  key={item.value}
                  label={item.label}
                  value={item.value}
                />
              ))}
            </Stack>
          </ScrollArea>
        </Radio.Group>
      )}
      {selectElement === 'checkbox' && (
        <Checkbox.Group
          value={state.value as string[]}
          onChange={(value) => functions.setValue(value)}
        >
          <ScrollArea mih='50vh' type='never'>
            <Stack gap={16}>
              {state.filteredCity.map((item) => (
                <LBCheckbox
                  key={item.value}
                  label={item.label}
                  value={item.value}
                />
              ))}
            </Stack>
          </ScrollArea>
        </Checkbox.Group>
      )}
      <Space h={100} />
      <Flex bottom={60} pos='sticky'>
        <LBButton fullWidth type='button' onClick={() => onSelect(state.value)}>
          <FormattedMessage id='commons.save-and-continue' />
        </LBButton>
      </Flex>
    </div>
  );
};
